import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_TOPICS, FETCH_TOPIC, TOPIC_REMOVE, TOPIC_SAVE, TOPICS_LIST_SAVE, FETCH_ERROR } from './actions.type'
import { SET_TOPICS, SET_TOPICS_ERRORS, SET_TOPICS_LOADING, SET_TOPIC, SET_TOPIC_ERRORS, SET_TOPIC_LOADING, SET_TOPICS_LIST_LOADING } from './mutations.type'
import Constants from '@/common/constants'

const state = {
	topics: [],
	topicsErrors: [],
	topicsIsLoading: false,
	topic: null,
	topicErrors: [],
	topicIsLoading: false,
	topicsListIsLoading: false
}

const getters = {
	topics:state => key => {
		return state.topics.filter(x => x.name.toLowerCase().includes(key.toLowerCase())).sort(function(a,b) { return a.order_t - b.order_t })
	},
	topicsErrors (state) {
		return state.topicsErrors
	},
	topicsIsLoading (state) {
		return state.topicsIsLoading
	},
	topic (state) {
		return state.topic
	},
	topicErrors (state) {
		return state.topicErrors
	},
	topicIsLoading (state) {
		return state.topicIsLoading
	},
	topicsListIsLoading (state) {
		return state.topicsListIsLoading
	}
}

const actions = {
	[FETCH_TOPICS] (context, params) {
		context.commit(SET_TOPICS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/topics')
			.then(({data}) => {
				if (typeof data == "object") {
					data.push({ id: Constants.EMPTY_ID, name: "Раздел не задан", order_t: Math.max.apply(Math, data.map(function(o) { return o.order_t })) + 1 })
					context.commit(SET_TOPICS, data)
					resolve(data)
				} else {
					context.commit(SET_TOPICS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_TOPICS_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_TOPICS_LOADING, false)
			})
		})
	},
	[FETCH_TOPIC] (context, params) {
		context.commit(SET_TOPIC_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy('manager/topics', params.id)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_TOPIC, data)
					resolve(data)
				} else {
					context.commit(SET_TOPIC_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_TOPIC_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_TOPIC_LOADING, false)
			})
		})
	},
	[TOPIC_SAVE] (context, params) {
		context.commit(SET_TOPIC_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/topics/${params.id}`, params)
			.then(({data}) => {
				if (data) {
					if (data === true) {
						this.dispatch(FETCH_ERROR, { variant: "success", text: "Тематический раздел сохранен", title: "Готово" })
					}
					else {
						this.dispatch(FETCH_ERROR, { variant: "success", text: "Тематический раздел создан", title: "Готово" })
					}
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}	
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_TOPIC_LOADING, false)
			})
		})
	},
	[TOPIC_REMOVE] (context, id) {
		context.commit(SET_TOPIC_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.delete(`manager/topics/${id}`)
			.then(({data}) => {
				if (data) {
					state.topics = state.topics.filter(x => x.id != id)
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Тематический раздел удален", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_TOPIC_LOADING, false)
			})
		})
	},
	[TOPICS_LIST_SAVE] (context, params) {
		context.commit(SET_TOPICS_LIST_LOADING)
		var p = params.map(x => {
			return { id: x.id, order_t: x.order_t }
		})
		return new Promise((resolve, reject) => {
			ApiService.put('manager/topics', p)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Порядок тематических разделов сохранен", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}
				resolve(data)
			})
			.catch((error) => {
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_TOPICS_LIST_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_TOPICS] (state, data) {
		state.topics = data
		state.topicsErrors = []
	},
	[SET_TOPICS_ERRORS] (state, errors) {
		state.topics = []
		state.topicsErrors = errors
	},
	[SET_TOPICS_LOADING] (state, status = true) {
		state.topicsIsLoading = status
	},
	[SET_TOPIC] (state, data) {
		state.topic = data
		state.topicErrors = []
	},
	[SET_TOPIC_ERRORS] (state, errors) {
		state.topic = null
		state.topicErrors = errors
	},
	[SET_TOPIC_LOADING] (state, status = true) {
		state.topicIsLoading = status
	},
	[SET_TOPICS_LIST_LOADING] (state, status = true) {
		state.topicsListIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/topics.module.js